(ns dashboard.views.workbook-workspace.subs
  (:require [re-frame.core :as rf]
            [io.repliance.questionnaire.utils :as q-utils]))

(rf/reg-sub
  ::workbook-workspace.browser
  (comp :browser :workbook-workspace))

(rf/reg-sub
  ::workbook-workspace.active-workbook
  (fn [db]
    (let [{:keys [questionnaire sheet-id]} (get-in db [:workbook-workspace :grid])
          active-workbook-sheet (get-in db [:workbook-workspace :workbooks questionnaire sheet-id])

          {:keys [hidden-rows
                  rows
                  show-hidden-rows?]} active-workbook-sheet

          rows-to-render (if (and hidden-rows (not show-hidden-rows?))
                           (remove (comp hidden-rows first)
                                   rows)
                           rows)]

      (assoc active-workbook-sheet
             :rows
             rows-to-render
             :questionnaire questionnaire
             :sheet sheet-id))))

(rf/reg-sub
 ::workbook-workspace.state
 (fn [db]
   (:workbook-workspace db)))

(defn get-grid [db]
  (get-in db [:workbook-workspace :grid]))

(rf/reg-sub
  ::workbook-workspace.grid
  (fn [db _]
    (get-grid db)))

(rf/reg-sub
  ::workbook-workspace.results
  (fn [db]
    (let [{:keys [questionnaire sheet-id]} (get-grid db)
          {:keys [parsing-config rows] sheet-name :name} (get-in db [:workbook-workspace :workbooks questionnaire sheet-id])]
      (q-utils/apply-parsing-configuration-to-rows {:sheet          {:rows          rows
                                                                     :sheet         sheet-name
                                                                     :uuid          sheet-id}
                                                    :parsing-config parsing-config}))))

(rf/reg-sub
  ::workbook-workspace.context-menu
  (comp :context-menu :workbook-workspace))

(rf/reg-sub
  ::parsing-config
  (fn [db [_ questionnaire sheet-id]]
    (get-in db [:workbook-workspace :workbooks questionnaire sheet-id :parsing-config])))
